import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { Workspace } from '@/features/iam/workspaces/Workspace'
import type { UserTransactionReason } from '@/features/payouts/user-transaction-reason'
import type { TransactionType } from '@/features/payouts/transaction-type'
import type { TransactionSourceType } from '@/features/payouts/transaction-source-type'
import { unixEpoch } from '@/utils/date-util'
import { type Job } from '@/features/jobs/Job'

export type ProHistoricalTransactionProps = ModelProps<ProHistoricalTransaction>

/**
 * A historical payout transaction, from the Pro perspective.
 */
export class ProHistoricalTransaction extends Model<ProHistoricalTransaction> {
  id = Id.none
  @observable accessor shortId = ''
  @observable accessor amount = 0
  @observable accessor type: TransactionType = 'Payment'
  @observable accessor workspace = Workspace.none
  @observable accessor source: TransactionSourceType = 'Unknown'
  @observable accessor reason: UserTransactionReason | null = 'Unknown'
  @observable accessor memo: string | null = null
  @observable accessor completedAt = unixEpoch()
  @observable accessor payoutId: Id | null = null
  @observable accessor stripeAccountId: string | null = null

  @observable accessor job: Job | null = null
}
